// src/utils/brandSearch.js
// The backend's /brands/search only matches KOREAN brand names, so English
// queries always return zero results. This resolver maps an English query
// (official name, or the old machine-translated name) to the Korean brand
// name(s) so searchBrands can retry against the backend with those.
import BRAND_NAMES from '../constants/brandNamesEn.json';

const normalize = (s) =>
  String(s)
    .toLowerCase()
    .replace(/[^a-z0-9가-힣]/g, '');

const ENTRIES = Object.entries(BRAND_NAMES).map(([id, b]) => ({
  id,
  ko: b.ko,
  en: b.en,
  keys: [normalize(b.en), b.alias ? normalize(b.alias) : null].filter(Boolean),
}));

const HAS_HANGUL = /[가-힣]/;

/**
 * Resolves an English brand query to Korean brand names for backend search.
 * Returns up to `limit` candidates, exact matches first, then prefix, then
 * substring. Returns [] for Korean queries or no match.
 */
/** Official English name for a brand_id, or null if unknown. */
export const englishBrandName = (brandId) => BRAND_NAMES[brandId]?.en || null;

export const resolveEnglishBrandQuery = (query, limit = 5) => {
  if (!query || HAS_HANGUL.test(query)) return [];
  const q = normalize(query);
  if (!q) return [];

  const exact = [];
  const prefix = [];
  const partial = [];
  for (const e of ENTRIES) {
    if (e.keys.some((k) => k === q)) exact.push(e);
    else if (e.keys.some((k) => k.startsWith(q))) prefix.push(e);
    else if (q.length >= 3 && e.keys.some((k) => k.includes(q))) partial.push(e);
  }
  return [...exact, ...prefix, ...partial].slice(0, limit);
};

export default resolveEnglishBrandQuery;
